/**
 * @作者: c-xuminghao
 * @Date: 2022-05-30 12:39:58
 * @描述: 
 * @安全等级: 秘密
 */
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import less from 'less'
import App from './App'
import router from './router'
import "@/assets/font.css"

Vue.use(ElementUI)
Vue.use(less)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
